import React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from '../../../common/Button';
import Render from '../../../common/Render';
import { scrollToHash } from '../../../utils/scrollToHash';
import ListItem from './ListItem';
import { requestDataIfNeeded } from '../../../memos/duck';

class Memos extends React.Component {
  async componentDidMount() {
    const projectId = this.props.project._id;
    await this.props.requestProjectMemosDataIfNeeded({ project: projectId });

    scrollToHash();
  }

  componentDidUpdate(prevProps) {
    const currentProjectId = this.props.project._id;
    const isDifferentProject = currentProjectId !== prevProps.project._id;
    if (isDifferentProject) {
      this.props.requestProjectMemosDataIfNeeded({
        project: currentProjectId,
      });
    }
  }

  renderAfterLoading = () => {
    const { memos, t, handleOnShareClick, project, currentUserId } = this.props;

    return (
      <React.Fragment>
        {_.isEmpty(memos) && (
          <div className="o-layout__item u-margin-bottom">
            <p className="u-weight-light">{t('project.memo.noMemos')}</p>
            <Button styleType="outline" onClick={handleOnShareClick}>
              {t('project.memo.btn')}
            </Button>
          </div>
        )}

        {!_.isEmpty(memos) && (
          <div className="o-layout u-margin-top">
            <div className="o-layout__item">
              {memos.map((memo) => (
                <ListItem
                  key={memo._id}
                  memo={memo}
                  project={project}
                  currentUserId={currentUserId}
                  isCurrentlyLoggedInUserMemo={memo.user._id === currentUserId}
                />
              ))}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapStateToProps = ({ projectMemos, user }) => ({
  isLoading: projectMemos.isLoading,
  error: projectMemos.error,
  memos: projectMemos.data,
  currentUserId: user.data && user.data._id,
});

const mapDispatchToProps = {
  requestProjectMemosDataIfNeeded: requestDataIfNeeded,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Memos));



// WEBPACK FOOTER //
// ./src/projects/details/memos/List.js